'use strict';

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (theme) {
  return {
    bg: {
      display: 'flex',
      alignContent: 'center',
      alignItems: 'center',
      position: 'fixed',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: 'rgba(57, 63, 70, 0.8)',
      transition: theme.transition(['opacity']),
      opacity: 0,
      zIndex: 1000,
      '&.visible': {
        opacity: 1
      }
    },
    modal: {
      display: 'flex',
      flexDirection: 'column',
      margin: 'auto',
      maxHeight: '80%',
      boxSizing: 'border-box',
      borderRadius: theme.modal.borderRadius,
      backgroundColor: theme.modal.bgColor,
      boxShadow: theme.modal.boxShadow,
      padding: theme.modal.padding,
      transform: 'translate3d(0,-100px,0)',
      transition: theme.transition(['transform'], 400, 0),
      overflow: 'hidden',
      '&.error': {
        backgroundColor: theme.modal.errorColor
      },
      '&.visible': {
        transform: 'translate3d(0,0,0)'
      }
    },
    small: {
      width: theme.modal.small
    },
    medium: {
      width: theme.modal.medium
    },
    large: {
      width: theme.modal.large
    },
    label: {
      marginBottom: theme.modal.spacingVertical,
      color: theme.modal.titleColor
    },
    closeIcon: {
      position: 'absolute',
      top: 15,
      right: 15,
      cursor: 'pointer'
    }
  };
};